import React, { PureComponent } from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import TermsOfServiceModal from 'containers/TermsOfServiceModal';
import SuppressSecondaryContent from 'utils/SuppressSecondaryContent';

class TermsOfServiceUpdatedPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showTOS: false
    };
    this.handleAccept = this.handleAccept.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleAccept() {
    return this.props.doAcceptTOS();
  }

  handleLogout() {
    this.props.redirectToLogout();
  }

  componentDidMount() {
    this.setState({ showTOS: true });
  }

  render() {
    return (
      <div className="terms-of-service-updated-page">
        <SuppressSecondaryContent />
        <TermsOfServiceModal
          show={this.state.showTOS}
          onAccept={this.handleAccept}
          onLogout={this.handleLogout}
        />
      </div>
    );
  }
}

const MUTATION_UPDATE_TOS = gql`
  mutation MyAcceptTermsOfService {
    acceptTermsOfService
  }
`;

const withAcceptTOS = graphql(MUTATION_UPDATE_TOS, {
  props: ({ ownProps: { redirectToHome }, mutate }) => ({
    doAcceptTOS: () => {
      return mutate().then(({ data }) => {
        if (data.acceptTermsOfService) {
          redirectToHome();
        }
        return data;
      });
    }
  })
});

const mapDispatchToProps = dispatch => ({
  redirectToHome: () => dispatch(push('/')),
  redirectToLogout: () => dispatch(push('/logout'))
});

const withConnect = connect(null, mapDispatchToProps);

export default withConnect(withAcceptTOS(TermsOfServiceUpdatedPage));
